export default "__VITE_ASSET__BhRImGV4__"